import shrutiAvatar from '../../Assets/Images/shruti.svg';

const IntroSection = ({ items = [], onButtonClick, onShrutiClick }) => {
  if (!items.length) return null;

  const {
    heading,
    subheading,
    description,
    button1,
    button2,
    image,
    onButton2Click,
  } = items[0];

  return (
    <>
      <style>{`
        .intro-section {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;
          overflow: hidden;
          background-color: #ffffff;
          background-image: var(--section-bg-gradient);
        }

        .intro-content-wrapper {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
          width: 100%;
          /* side padding matches .cb-section; bottom leaves room for the cards that overlap the hero by 80px */
          padding: 32px max(60px, calc(50% - 660px)) 128px;
          box-sizing: border-box;
        }

        /* desktop sizes scale with viewport width up to the 1440px Figma frame, then stay at the Figma size
           (content is capped to that frame on wider screens, so text/buttons must stop growing too) */
        .intro-text {
          flex: 0 0 auto;
          width: 50%;
        }

        .intro-heading,
        .intro-subheading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: clamp(40px, 3.6vw, 51.8px);
          line-height: 1.2;
          letter-spacing: 0.3%;
          display: block;
        }

        .intro-heading {
          color: var(--color-brand-primary);
          margin: 0;
        }

        .intro-subheading {
          color: var(--color-brand-green);
          margin: 0 0 clamp(20px, 1.8vw, 25.9px) 0;
          white-space: pre-line;
        }

        .intro-description {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: clamp(20px, 1.75vw, 25.2px);
          line-height: 1.35;
          letter-spacing: 0;
          color: var(--color-text-subheading);
          margin: 0 0 clamp(32px, 3.2vw, 46.1px) 0;
        }

        .intro-buttons {
          display: flex;
          gap: clamp(16px, 1.4vw, 20.2px);
          align-items: center;
          flex-wrap: wrap;
        }

        .intro-btn1,
        .intro-btn2 {
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: clamp(16px, 1.15vw, 16.6px);
          min-width: clamp(240px, 22vw, 316.8px);
          padding: clamp(12px, 0.95vw, 13.7px) 40px;
          border-radius: 999px;
          border: 1.5px solid var(--color-brand-primary);
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s, transform 0.15s;
          outline: none;
        }

        .intro-btn1 {
          background: var(--color-brand-primary);
          color: #ffffff;
        }
        .intro-btn1:hover {
          background: var(--color-brand-primary-hover);
          transform: translateY(-1px);
        }

        .intro-btn2 {
          background: #ffffff;
          color: var(--color-brand-primary);
        }
        .intro-btn2:hover {
          background: #EAF3FA;
          transform: translateY(-1px);
        }

        .intro-image-wrap {
          flex: 0 0 auto;
          width: 36%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .intro-image-wrap img.intro-hero-img {
          width: 88%;
          object-fit: contain;
          display: block;
        }

        /* Shruti banner */
        .shruti-card {
          position: relative;
          display: flex;
          align-items: center;
          gap: clamp(12px, 1vw, 14.4px);
          width: 100%;
          margin-top: -16px;
          padding: clamp(12px, 1vw, 14.4px) clamp(16px, 1.3vw, 18.7px) clamp(12px, 1vw, 14.4px) clamp(12px, 1vw, 14.4px);
          background: #ffffff;
          border: 1px solid #C9EEF8;
          border-radius: 16px;
          box-shadow: 0px 4px 10px 0px #80DAF180;
          box-sizing: border-box;
        }

        .shruti-avatar {
          flex: 0 0 auto;
          width: clamp(76px, 6vw, 86.4px);
          height: clamp(76px, 6vw, 86.4px);
          object-fit: contain;
        }

        .shruti-body {
          flex: 1 1 auto;
          min-width: 0;
        }

        .shruti-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 6px;
        }

        .shruti-title {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: clamp(18px, 1.4vw, 20.2px);
          color: var(--color-brand-primary);
          margin: 0;
          white-space: nowrap;
        }

        .shruti-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          font-size: clamp(13px, 1vw, 14.4px);
          color: #ffffff;
          background: var(--color-brand-primary);
          border: none;
          border-radius: 999px;
          padding: clamp(7px, 0.6vw, 8.6px) clamp(16px, 1.3vw, 18.7px);
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s;
        }
        .shruti-btn:hover { background: var(--color-brand-primary-hover); }

        .shruti-text {
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          font-size: clamp(12px, 0.95vw, 13.7px);
          line-height: 1.5;
          color: #5B5B5B;
          margin: 0;
        }

        /* TABLET LARGE (1100–1279px) */
        @media (max-width: 1279px) and (min-width: 1101px) {
          .intro-content-wrapper { padding: 32px 40px 128px; }
          .intro-heading, .intro-subheading { font-size: 40px; }
          .intro-description { font-size: 20px; }
        }

        /* TABLET (768px–1100px) */
        @media (max-width: 1100px) and (min-width: 768px) {
          .intro-content-wrapper { padding: 28px 28px 64px; gap: 24px; }
          .intro-heading, .intro-subheading { font-size: 30px; }
          .intro-description { font-size: 16px; margin-bottom: 28px; }
          .intro-text { width: auto; flex: 1 1 0; }
          .intro-image-wrap { width: 44%; }
          .intro-btn1, .intro-btn2 { font-size: 14px; min-width: 0; padding: 10px 28px; }
          .shruti-top { flex-direction: column; align-items: flex-start; }
        }

        /* MOBILE (max 767px) */
        @media (max-width: 767px) {
          .intro-content-wrapper {
            flex-direction: column;
            padding: 24px 14px 40px;
            gap: 24px;
          }
          .intro-image-wrap { width: 100%; max-width: 420px; }
          .intro-image-wrap img.intro-hero-img { width: 100%; max-width: 280px; }
          .intro-text { width: 100%; max-width: 100%; text-align: center; }
          .intro-heading, .intro-subheading { font-size: clamp(24px, 7vw, 32px); }
          .intro-description { font-size: 15px; margin-bottom: 24px; }
          .intro-buttons { justify-content: center; flex-direction: column; width: 100%; }
          .intro-btn1, .intro-btn2 { width: 100%; min-width: 0; padding: 12px 24px; }
          .intro-image-wrap { order: 2; }
        }

        /* SMALL MOBILE (max 480px) */
        @media (max-width: 480px) {
          .intro-heading, .intro-subheading { font-size: clamp(22px, 6.5vw, 28px); }
          .intro-description { font-size: 14px; }
          .shruti-avatar { width: 60px; height: 60px; }
          .shruti-top { flex-direction: column; align-items: flex-start; }
        }
      `}</style>

      <div className="intro-section">
        <div className="intro-content-wrapper">
          <div className="intro-text">
            <span className="intro-heading">{heading}</span>
            <span className="intro-subheading">{subheading}</span>
            <p className="intro-description">{description}</p>
            <div className="intro-buttons">
              {button1 && (
                <button className="intro-btn1" onClick={onButtonClick}>
                  {button1}
                </button>
              )}
              {button2 && (
                <button className="intro-btn2" onClick={onButton2Click}>
                  {button2}
                </button>
              )}
            </div>
          </div>

          <div className="intro-image-wrap">
            {image && <img className="intro-hero-img" src={image} alt="AI Healthcare" />}

            <div className="shruti-card">
              <img className="shruti-avatar" src={shrutiAvatar} alt="Shruti" />
              <div className="shruti-body">
                <div className="shruti-top">
                  <p className="shruti-title">Hello, I'm Shruti 👋</p>
                  <button className="shruti-btn" onClick={onShrutiClick}>
                    Talk to Shruti <span aria-hidden="true">→</span>
                  </button>
                </div>
                <p className="shruti-text">
                  I'm here to listen. Share what's on your mind about your health, in your own words.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroSection;
